import React from 'react'
import Svg from '../Svg'

export default ({
  width = 20,
  height = 20,
  'aria-label': ariaLabel,
  className = '',
}) =>
  <Svg
    className={ className }
    width={ width }
    height={ height }
    viewBox="0 0 1024 1024"
    aria-label={ ariaLabel }
  >
    <path d="M944.533 305.598c-81.868-11.771-169.057-20.296-260.041-25.095l152.008-152.008-59-59-207.013 207.011c-19.366-0.338-38.861-0.511-58.487-0.511v0l-236-236-59 59 179.026 179.026c-111.477 3.912-217.873 13.389-316.561 27.577-25.382 99.311-39.465 209.037-39.465 324.402s14.083 225.091 39.459 324.4c132.422 19.037 278.72 29.6 432.541 29.6s300.115-10.563 432.533-29.6c25.384-99.309 39.467-209.035 39.467-324.4s-14.083-225.091-39.467-324.402zM836.402 846.266c-99.315 12.691-209.035 19.736-324.402 19.736s-225.091-7.045-324.402-19.736c-19.033-66.206-29.598-139.356-29.598-216.265s10.563-150.065 29.598-216.266c99.311-12.691 209.035-19.734 324.402-19.734 115.361 0 225.087 7.043 324.396 19.734 19.041 66.206 29.604 139.356 29.604 216.266 0 76.908-10.563 150.063-29.598 216.265z"/>
  </Svg>
